import locale from "localization";
import styles from "./shift-details-stock-inventory.module.scss";
import { prettifyProductCode } from "utils/pretty.utils";
import ProductCode from "enums/product-code";
import { Title } from "components/commons";
import FuelSummary from "./shift-details-fuel-product-summary";
import { sortBy } from "lodash";
import { useMemo } from "react";

const ShiftDetailsFuelSales = ({
  shift,
  form,
  isShiftEndedCompletely,
  // recentShiftDetails,
}) => {
  // shift = {
  //   ...shift,
  //   recentShift: null,
  // };
  const diesel = sortBy(shift?.transactionItem.dieselTransactionItem, "metadata");
  const gas91 = sortBy(shift?.transactionItem.gas91TransactionItem, "metadata");
  const gas95 = sortBy(shift?.transactionItem.gas95TransactionItem, "metadata");
  const gas97 = sortBy(shift?.transactionItem.gas97TransactionItem, "metadata");

  const shiftPumpTotalsFields = useMemo(
    () => form.fields.shiftPumpTotals.value || [],
    [form.fields.shiftPumpTotals],
  );

  const updatePumpTotal = (pump, updates) => {
    const shiftPumpTotalsFields = form.fields.shiftPumpTotals.value || [];
    const existingIndex = shiftPumpTotalsFields.findIndex((t) => t.fuelingPointId === pump);

    const updatedTotals =
      existingIndex >= 0
        ? shiftPumpTotalsFields.map((t, i) => (i === existingIndex ? { ...t, ...updates } : t))
        : [...shiftPumpTotalsFields, { ...updates }];

    form?.modifyForm({
      shiftPumpTotals: { value: updatedTotals },
    });
  };

  const handleOnChangePumpTotalizers = ({ productName, pump, isStart, value }) => {
    const sanitized = productName.replace(/\s/g, "");
    const key = `${isStart ? "start" : "end"}Totalizer${sanitized}`;
    updatePumpTotal(pump, { [key]: value });
  };

  const handleOnChangePumpRemarks = ({ productName, pump, value }) => {
    const sanitized = productName.replace(/\s/g, "");
    updatePumpTotal(pump, { [`remarks${sanitized}`]: value });
  };

  return (
    <>
      <Title small black>
        {locale.fuelSales}
      </Title>

      <div className={styles.tableContainer}>
        <div className={styles.fuelSalesTable}>
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={diesel}
            name={prettifyProductCode(ProductCode.DIESEL)}
            sku={ProductCode.DIESEL}
            transactions={shift.transactionItem.dieselTransactions}
            handleOnChangePumpTotalizers={handleOnChangePumpTotalizers}
            handleOnChangePumpRemarks={handleOnChangePumpRemarks}
            shiftPumpTotalsFields={shiftPumpTotalsFields}
            form={form}
            // recentShiftDetails={recentShiftDetails}
          />
          <div className={styles.spacer20} />
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={gas91}
            name={prettifyProductCode(ProductCode.GAS91)}
            sku={ProductCode.GAS91}
            transactions={shift.transactionItem.gas91Transactions}
            handleOnChangePumpTotalizers={handleOnChangePumpTotalizers}
            handleOnChangePumpRemarks={handleOnChangePumpRemarks}
            shiftPumpTotalsFields={shiftPumpTotalsFields}
            form={form}
            // recentShiftDetails={recentShiftDetails}
          />
          <div className={styles.spacer20} />
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={gas95}
            name={prettifyProductCode(ProductCode.GAS95)}
            sku={ProductCode.GAS95}
            transactions={shift.transactionItem.gas95Transactions}
            handleOnChangePumpTotalizers={handleOnChangePumpTotalizers}
            handleOnChangePumpRemarks={handleOnChangePumpRemarks}
            shiftPumpTotalsFields={shiftPumpTotalsFields}
            form={form}
            // recentShiftDetails={recentShiftDetails}
          />
          <div className={styles.spacer20} />
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={gas97}
            name={prettifyProductCode(ProductCode.GAS97)}
            sku={ProductCode.GAS97}
            transactions={shift.transactionItem.gas97Transactions}
            handleOnChangePumpTotalizers={handleOnChangePumpTotalizers}
            handleOnChangePumpRemarks={handleOnChangePumpRemarks}
            shiftPumpTotalsFields={shiftPumpTotalsFields}
            form={form}
            // recentShiftDetails={recentShiftDetails}
          />
        </div>
      </div>
    </>
  );
};

export default ShiftDetailsFuelSales;
